import { getUserList } from '../userManagement/user/userService';

export function getUserListIntegrated() {
  return getUserList();
}
